import Event from '../../core/Event';
import { Filter } from '../../../domain/Filter';

export default class EstimationsFilterSelected extends Event {
    public static type = 'EstimationsFilterSelected';

    constructor(public readonly filter: Filter) {
        super(EstimationsFilterSelected.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/EstimationsFilterSelected.ts